import React, { useRef } from "react";
import "./DynaInputFile.scss";
import "./DynaInput.scss";

const DynaInputFile = (props) => {
  const fileInputRef = useRef(null);

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        props.setSendData({ ...props.sendData, [props.name]: file });
      };
      reader.readAsDataURL(file);
    }
  };

  const openFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const fileValue = props.sendData?.[props.name];

  const getButtonText = () => {
    if (fileValue instanceof File) {
      return <p>{fileValue.name}</p>;
    }
    if (typeof fileValue === "string" && fileValue.trim()) {
      return <p>دارد</p>;
    }
    return <p>انتخاب فایل</p>;
  };

  return (
    <div
      className={`main-dyna-input main-dyna-file ${
        props.className !== undefined ? props.className : ""
      }`}
      style={props.style ? props.style : {}}
    >
      <label htmlFor={props.name}>{props.label}</label>
      <button className="cssbuttons-io-button" onClick={openFileInput}>
        {getButtonText()}
      </button>

      <input
        type={"file"}
        ref={fileInputRef}
        onChange={handleFileInputChange}
        accept={props.accept !== undefined && props.accept}
      />
    </div>
  );
};

export default React.memo(DynaInputFile);
